"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFileUploader = void 0;
// hooks/useFileUploader.ts
const react_1 = require("react");
const config_1 = require("../../config");
const uploadDebug_1 = require("../../utils/uploadDebug");
const useFileUploader = () => {
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)(null);
    const uploadFile = (params) => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        setError(null);
        try {
            const token = (0, config_1.getAuthToken)();
            const formData = new FormData();
            formData.append("file", params.file);
            formData.append("module", params.module);
            formData.append("permission", params.permission);
            formData.append("mimetype", params.file.type); // Add mimetype
            formData.append("filename", params.file.name); // Add filename for better tracking
            // Debug logging
            (0, uploadDebug_1.debugUpload)(params.file, formData);
            // Don't set Content-Type header when using FormData
            // Let the browser set it automatically with the boundary
            const headers = {};
            if (token) {
                headers.Authorization = `Bearer ${token}`;
            }
            const isImage = params.file.type.startsWith("image/");
            const uploadUrl = isImage
                ? `${config_1.API_BASE_URL}/v1/files/upload` // image upload URL
                : `${config_1.UPLOAD_BASE_URL}/upload-file`; // generic file upload URL
            console.log('🚀 Uploading to:', uploadUrl);
            console.log('🔑 Headers:', headers);
            const response = yield fetch((0, config_1.withAppName)(uploadUrl), {
                method: 'POST',
                headers,
                body: formData,
            });
            if (!response.ok) {
                const errorText = yield response.text();
                const errorMessage = `Upload failed: ${response.status} - ${errorText}`;
                console.error('❌ Upload failed:', errorMessage);
                throw new Error(errorMessage);
            }
            const data = yield response.json();
            (0, uploadDebug_1.debugUploadResponse)(response, data);
            console.log('✅ Upload successful:', data);
            const objData = (data === null || data === void 0 ? void 0 : data.data) ? data === null || data === void 0 ? void 0 : data.data : data;
            return Object.assign(Object.assign({}, objData), { fileType: params.uploadType, mimetype: params.file.type, filename: params.file.name });
        }
        catch (err) {
            (0, uploadDebug_1.debugUploadError)(err, 'useFileUploader.uploadFile');
            const errorMessage = (err === null || err === void 0 ? void 0 : err.message) || "Upload failed";
            setError(errorMessage);
            throw err;
        }
        finally {
            setLoading(false);
        }
    });
    return { uploadFile, loading, error };
};
exports.useFileUploader = useFileUploader;
